// #region Imports
/**
 * To use react related functionality
 */
import React from 'react';
// #endregion

// A CSS-only loading spinner
const Spinner = props => {
    return(
        <div className={`otp-spinner ${props.color}`}>
            {props.text}
        </div>
    );
};

//set default props
Spinner.defaultProps = {
    //text of the loader
    text: 'Loading...',
    //color of the loader
    color: 'blue'
};

export default Spinner;